import { Box } from '@mui/material';
import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Spinner } from 'src/components/spinner';
import { useIsUserAuthenticated } from 'src/lib/hooks/use-is-user-authenticated';
import { selectUserLoggedIn } from 'src/store/slices/user-slice';
import { routes } from 'src/constants/routes';
import { LoginDialog } from 'src/features/login-dialog';
import { setVitaRefStorage } from 'src/utils/local-storage-versioning';

import { FailurePage } from '../../failure';
import { styles as bookingDetailsStyles } from '../../booking-details/styles';

import { AmendBookingPage } from './amend-booking-page';

export const AmendBookingWrapper: FC = () => {
    const userLoggedIn = useSelector(selectUserLoggedIn);
    const navigate = useNavigate();

    const { error, isFetching } = useIsUserAuthenticated(!userLoggedIn);
    const [showPasswordReset, setShowPasswordReset] = useState<boolean>(false);

    const [searchParams] = useSearchParams();

    const vitaRef = searchParams.get('vitaRef');

    if (!vitaRef) return <FailurePage />;

    setVitaRefStorage(vitaRef);

    const handleShowPasswordReset = () => {
        setShowPasswordReset(!showPasswordReset);
    };

    if (isFetching) {
        return (
            <Box css={bookingDetailsStyles.layout}>
                <Box css={bookingDetailsStyles.leftSide}>
                    <Spinner />
                </Box>
            </Box>
        );
    }

    if (error || !vitaRef) {
        navigate(routes.failure.index);
        return null;
    }

    if (!userLoggedIn) {
        return (
            <Box css={bookingDetailsStyles.layout}>
                <Box css={bookingDetailsStyles.leftSide}>
                    <LoginDialog
                        open
                        closeFn={() => {}}
                        showPasswordReset={showPasswordReset}
                        handleShowPasswordReset={handleShowPasswordReset}
                        currentEmail={null}
                        redirectUrl={`${window.location.origin}${routes.callback.amendBooking}`}
                    />
                </Box>
            </Box>
        );
    }

    return <AmendBookingPage vitaRef={vitaRef} />;
};
